import React from "react";
import { useDrop } from "react-dnd";
import { SOCIAL_LINK_DND_TYPE } from "./selected-social-link"; // Or your local path
import { ArrowLeftRight } from "lucide-react";

export interface ISocialLinkDropZoneProps {
  dropIndex: number; // Where to insert (between which links)
  onDrop: (fromIdx: number, toIdx: number) => void;
  isActive?: boolean; // For visual cue if you want (not required)
}

export default function SocialLinkDropZone ({
  dropIndex,
  onDrop,
  isActive,
}: ISocialLinkDropZoneProps) {
  const [{ isOver, canDrop }, dropRef] = useDrop({
    accept: SOCIAL_LINK_DND_TYPE,
    drop: (item: { index: number }) => {
      if (item.index !== dropIndex) {
        onDrop(item.index, dropIndex);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  // Show highlight when item is over or it's the active drop target
  const highlight = isOver || isActive;

  return (
    <div
      ref={dropRef}
      className={`
        flex items-center justify-center
        transition-all duration-150
        ${isOver
          ? "bg-blue-100 border-blue-400 h-8 border-2 shadow-md"
          : "bg-transparent border-transparent h-[2px]"}
        w-full rounded pointer-events-auto
      `}
      style={{
        minHeight: isOver ? 32 : 2,
        zIndex: isOver ? 20 : 1,
      }}
      aria-hidden="true"
    >
      {isOver && (
        <ArrowLeftRight
          size={18}
          className="transition-opacity duration-200"
          style={{ opacity: 0.5, color: "#3b82f6" }}
        />
      )}
    </div>
  );
}